import {inject, Injectable} from '@angular/core';
import {firstValueFrom} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {Trusted} from '@kilobytelab/types';
import {Educadora} from '@kilobytelab/types';
import {API_URL_TOKEN} from '../token';

@Injectable({
  providedIn: 'root'
})
export class ApiEducService {

  private http = inject(HttpClient);
  private apiUrl = inject(API_URL_TOKEN);

  /*** educadoras ***/

  getEducadoras(): Promise<Educadora[]> {
    const url = `${this.apiUrl}educadoras`;
    return firstValueFrom(this.http.get<Educadora[]>(url))
  }
  getEducadorasTrusted(): Promise<Trusted[]> {
    const url = `${this.apiUrl}educadoras/trusted`;
    return firstValueFrom(this.http.get<Trusted[]>(url))
  }
  addEducadora(datos: Educadora): Promise<any> {
    const url = `${this.apiUrl}educadoras`;
    return firstValueFrom(this.http.post<any>(url, datos))
  }
  resetTrusted(data: {BBDD: string, direccion: boolean}): Promise<any> {
    const url = `${this.apiUrl}educadoras/trusted/reset`;
    return firstValueFrom(this.http.post<any>(url, data))
  }
  updateEducadora(datos: Educadora): Promise<any> {
    const url = `${this.apiUrl}educadoras/${datos.idEducadora}`;
    return firstValueFrom(this.http.put<any>(url, datos))
  }
  updateEducadoraTrusted(data: {user: string, password: string, direccion: boolean}): Promise<any> {
    const url = `${this.apiUrl}educadoras/trusted`;
    return firstValueFrom(this.http.put<any>(url, data))
  }
  eliminarEducadora(idEducadora: number): Promise<any> {
    const url = `${this.apiUrl}educadoras/${idEducadora}`;
    return firstValueFrom(this.http.delete<any>(url))
  }

}
